/* =================== SERVIÇOS HOME =================== */
$(function () {
  $('.carrosel-servicos').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 760,
        settings: 'unslick',
      },
    ],
  });
});
